import React from 'react';

import { FormContainer } from '@eika-kortbetjening/form-container';

import fallbackDictionary from './fallbackDictionary';
import Footer from './footer/Footer';
import Form from './form/Form';
import { HardBlockReason, Piwik, SiteCoreDictionary } from './types';

import './BlockFormSelectReasonForHardBlock.scss';

interface BlockFormSelectReasonForHardBlockProps {
    /** Possible reason options */
    possibleReasons: HardBlockReason[];
    /** Selected reason */
    selectedReason: HardBlockReason | undefined;
    /** Function to set selected reason */
    setSelectedReason: (reason: HardBlockReason | undefined) => void;
    /** Selected reason form error */
    selectedReasonError: string | undefined;
    /** Function for the next button */
    next: () => void;
    /** Function for the cancel button */
    cancel: () => void;
    /** Sitecore dictionary */
    sitecoreDictionary?: SiteCoreDictionary;
    /** PIWIK tags */
    piwik?: Piwik;
}

const BlockFormSelectReasonForHardBlock = ({
    possibleReasons,
    selectedReason,
    setSelectedReason,
    selectedReasonError,
    next,
    cancel,
    sitecoreDictionary,
    piwik,
}: BlockFormSelectReasonForHardBlockProps): React.JSX.Element => {
    const dictionary = { ...fallbackDictionary, ...sitecoreDictionary };

    return (
        <FormContainer
            data-track-id={piwik?.blockCardForm?.blockFormSelectReasonForHardBlockForm?.dataTrackId}
            data-track-linkname={piwik?.blockCardForm?.blockFormSelectReasonForHardBlockForm?.dataTrackLinkname}
            id={piwik?.blockCardForm?.blockFormSelectReasonForHardBlockForm?.dataTrackId}
        >
            <FormContainer.Content>
                <Form
                    possibleReasons={possibleReasons}
                    selectedReason={selectedReason}
                    setSelectedReason={setSelectedReason}
                    selectedReasonError={selectedReasonError}
                    dictionary={dictionary}
                />
            </FormContainer.Content>
            <FormContainer.Footer>
                <Footer next={next} cancel={cancel} dictionary={dictionary} piwik={piwik} />
            </FormContainer.Footer>
        </FormContainer>
    );
};

export default BlockFormSelectReasonForHardBlock;
